export default [
  /* east */
  { description: '観測棟入口',
    file: './data/I3f.JPG',
    rotation: 11.517739897668198,
    link: [
    ],
    info: [
    ],
    view: {
      syowaZoom: [ 703.7861915367483, 549.0801781737193 ],
    },
    viewLocation: 'syowa',
    viewFloor: 'east',
  },
  { description: '管理棟下',
    file: './data/09_R0010761.JPG',
    rotation: 200,
    link: [
    ],
    info: [
    ],
    view: {
      syowaZoom: [ 979.9554565701559, 843.0668151447662 ],
    },
    viewLocation: 'syowa',
    viewFloor: 'east',
  },
  { description: '130kℓ水槽前',
    file: './data/14_R0010763.JPG',
    rotation: 70,
    link: [
    ],
    info: [
    ],
    view: {
      syowaZoom: [ 944.3207126948774, 618.1224944320713 ],
    },
    viewLocation: 'syowa',
    viewFloor: 'east',
  },
  { description: '発電棟２階廊下',
    file: './data/I13f_2.JPG',
    rotation: -8.877353032468307,
    link: [
    ],
    info: [
    ],
    view: {
      syowaZoom: [ 971.0467706013363, 716.1180400890869 ],
    },
    viewLocation: 'syowa',
    viewFloor: 'east',
  },

  /* west */
  { description: '発電棟前',
    file: './data/10_R0010762.JPG',
    rotation: 28.545938748335246,
    link: [
    ],
    info: [
    ],
    view: {
      syowaZoom: [ 35.634743875278396, 388.72383073496667 ],
    },
    viewLocation: 'syowa',
    viewFloor: 'west',
  },
  { description: '地学棟入口',
    file: './data/I10f.JPG',
    rotation: 67.05809957126333,
    link: [
    ],
    info: [
    ],
    view: {
      syowaZoom: [ 665.1835372636262, 366.3926585094548 ],
    },
    viewLocation: 'syowa',
    viewFloor: 'west',
  },

  /* 観測塔 */
  { description: '観測棟前',
    file: './data/11_R0010666.JPG',
    rotation: -61.335616274427686,
    link: [
    ],
    info: [
    ],
    view: {
      syowaZoom: [ 407.57238307349667, 613.6681514476614 ],
    },
    viewLocation: 'syowa',
    viewFloor: '観測棟',
  },

  /* 発電棟 */
  { description: '発電棟前',
    file: './data/10_R0010762.JPG',
    rotation: 28.545938748335246,
    link: [
    ],
    info: [
    ],
    view: {
      syowaZoom: [ 200.44543429844097, 186.05122494432067 ],
    },
    viewLocation: 'syowa',
    viewFloor: '発電棟',
  },
  { description: '防火区画A〜発電棟',
    file: './data/I59b_A.JPG',
    rotation: -62.264357560611856,
    link: [
    ],
    info: [
    ],
    view: {
      syowaZoom: [ 817.3719376391982, 424.3585746102449 ],
    },
    viewLocation: 'syowa',
    viewFloor: '発電棟',
  },

  /* 倉庫棟 */
  { description: '防火区画A',
    file: './data/I18u_A.JPG',
    rotation: -306.18612387083556,
    link: [
    ],
    info: [
    ],
    view: {
      syowaZoom: [ 104.67706013363029, 526.8084632516704 ],
    },
    viewLocation: 'syowa',
    viewFloor: '倉庫棟',
  },

  /* 地学棟*/
  { description: '地学棟前',
    file: './data/I10.JPG',
    rotation: -110,
    link: [
    ],
    info: [
    ],
    view: {
      syowaZoom: [ 605.7906458797328, 497.8552338530068 ],
    },
    viewLocation: 'syowa',
    viewFloor: '地学棟',
  },
]
